import { Component, Input } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { EditorContentService } from '../services/editorcontent.service';
import { TurtleService } from '../services/turtle.service';
import { CanvasService } from '../services/canvas.service';
import { CommandsService } from '../services/commands.service';
import { QuickStartService } from '../services/quickstart.service';
import { EnglishService } from '..//languages/english.service';
import { ItalianService } from '..//languages/italian.service';
import { GermanService } from '..//languages/german.service';

import { CanvasComponent } from './canvas.component';
import { AppComponent } from './app.component';
import { InputComponent } from './input.component';
import { SessionStorageService } from '../services/sessionstorage.service';
import { BlocksComponent } from './blocks.component';
import { BlocksService } from '../services/blocks.service';
import { BluetoothService } from 'app/services/bluetooth.service';
import { connect } from 'tls';

declare var require: (...any) => any;
declare var swal: any;

@Component({
  selector: 'header-component',
  templateUrl: './header.component.html',
  providers: [LanguageService, EditorContentService, TurtleService, CommandsService, SessionStorageService, BlocksService, BluetoothService]
})

export class HeaderComponent {

  @Input('languageServiceMaster') la: LanguageService;
  @Input('editorContentServiceMaster') et: EditorContentService;
  @Input('turtleServiceMaster') turtle: TurtleService;
  @Input('canvasServiceMaster') canvasService: CanvasService;
  @Input('commandsServiceMaster') commandsService: CommandsService;
  @Input('sessionstorageMaster') sessionstorage: SessionStorageService;
  @Input('blocksServiceMaster') blocks: BlocksService;
  @Input('bluetoothServiceMaster') bluetoothService: BluetoothService;

  // Variables related to the icons
  private iconVariable = 'app/img/countryIcons/english.png';
  private iconTurtleVariable = "app/img/turtles/turtle0.png"
  private navigationFullScreen = 'app/img/navigation/enterfullscreen.gif';
  private stopButton = 'app/img/navigation/stop.png';

  // Online or offline mode
  private runOffline = false;
  private quickstartService;

  private MAXSPEED = 10;
  private MINSPEED = 0;

  //automatic saving on or off
  private automaticsavingText;

  constructor() {

    (<any>window).setMat = this.setMat;

    // Close the dropdown if the user clicks outside of it
    window.onclick = function (event: MouseEvent) {
      // check whether dropdown menu was clicked or something else
      let el = <Element>event.target;
      //test whether headerbtn itself or its children were clicked (meaning any of the pictures)
      let selector = '.headerbtn, .headerbtn *';
      let p = Element.prototype;
      let f = p.matches || p.webkitMatchesSelector || p.msMatchesSelector ||
        function (s) {
          return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
        };

      // check whether dropdown menu was clicked or not
      let a = f.call(el, selector);

      // if it was not clicked, then close the dropdown menu
      if (!a) {
        let dropdowns = document.getElementsByClassName('dropdown-content');
        let i;
        for (i = 0; i < dropdowns.length; i++) {
          let openDropdown = dropdowns[i];
          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
          }
        }
      }
    };

    //Override CTRL-S with custom save mechanism --> download editor
    window.addEventListener('keydown', function (event) {
      if ((event.ctrlKey || event.metaKey) && String.fromCharCode(event.which).toLowerCase() === 's') {
        event.preventDefault();
        this.saveFile();
      }
    }.bind(this), false);

  }

  ngOnInit() {
    // set menu language icon accordingly
    switch (this.la.getLangAbbrev()) {
      case 'de':
        this.iconVariable = 'app/img/countryIcons/german.png';
        break;
      case 'en':
        this.iconVariable = 'app/img/countryIcons/english.png';
        break;
      case 'it':
        this.iconVariable = 'app/img/countryIcons/italian.png';
        break;
      default:
    }

    // register eventlistener for download link click
    document.getElementById('download').addEventListener('click', function () {
      this.canvasService.downloadAsPNG(document.getElementById('download'), "canvas");
    }.bind(this), false);


    // show promt to choose file on load file
    let x = <HTMLInputElement>document.createElement('INPUT');
    document.getElementById('loadFile').addEventListener('click', function () {
      x.value = null;
      x.setAttribute('type', 'file');
      x.setAttribute('accept', '.lgo');
      x.click();
    }, false);

    // load content of files on input file select
    x.addEventListener('change', function (event) {
      let file = x.files[0];
      let reader = new FileReader();
      (reader.onload = function (evt) {
        this.et.currentIndexTabs = 0;

        //delete all editors and all texts
        this.et.editorText = [];
        var ul = document.getElementById("tabs");
        while (ul.children.length > 1) {
          ul.removeChild(ul.firstChild);
        }

        //read input and separate it after $ and distribute it to multiple editors
        var allText = evt.target.result;
        allText = allText.split("$");
        var j = 0;

        for (var j = 0; j < allText.length; j++) {
          //add new tab with this content
          AppComponent.editor.setValue(allText[j], 1);
          this.et.addTab(false);
          this.et.editorText[this.et.currentHighlightTab] = allText[j];
        }

        //this.et.editorText[this.et.currentHighlightTab] = allText[j-1];
        AppComponent.editor.setValue(this.et.editorText[this.et.currentHighlightTab], 1);
      }.bind(this), false);
      reader.readAsText(file);
    }.bind(this), false);

    document.getElementById('speedFast').setAttribute('class', 'headerbtnS');
  }

  storeSpeedToSessionStorage() {
    this.sessionstorage.storeSpeed();
    let val = parseInt((<HTMLInputElement>document.getElementById('speedRange')).value);
    let prec = 0.95; // at 90% speed we will switch to very fast
    /* {speed} should be from 1000 (slow) to 0 (fast) or even negative (very fast)*/
    let speed = (val/this.MAXSPEED>prec)? -1 : Math.pow((this.MAXSPEED-val)/this.MAXSPEED,3)*this.MAXSPEED*100;
    InputComponent.updateTurtleSpeed(speed);
  }

  changeToSpeed(speed){
    (<HTMLInputElement>document.getElementById("speedRange")).value = speed;
    this.storeSpeedToSessionStorage()
  }

  //Connect and disconnect a BlueBot
  async startBlueBot() {

    if (this.bluetoothService.checkWhetherBluetoothConnected()) {
      swal({
        title: "A BlueBot is already connected. Do you want to disconnect?",
        confirmButtonText: "Yes, disconnect",
        showCancelButton: true
      })
        .then((value) => {
          if (value) (
            this.bluetoothService.disconnect()
          )
        })
    } else {
      swal({
        title: "Connect BlueBot?",
        confirmButtonText: "Yes, connect",
        showCancelButton: true
      })
        .then((value) => {
          if (value) {
            this.bluetoothService.connectBluebot()
          }
        })
    }
  }


  async startQuickstart() {
    //create QuickstartService only if it was not created before. Otherwise reuse
    if (!this.quickstartService) {
      this.quickstartService = new QuickStartService(AppComponent.editor, InputComponent.inputComponent, this);
    }

    //show options, 3 tutorials: first steps, editor and debugger
    const { value: country } = await swal({
      title: this.la.getLang()["doyouneedhelp"],
      input: 'select',
      inputOptions: {
        'ErsteSchritte': this.la.getLang()["firststeps"],
        'Editor': this.la.getLang()["definenewcommands"]//,
        //'Debugger': this.la.getLang()["debugger"]
      },
      inputPlaceholder: this.la.getLang()["tutorialtype"],
      showCancelButton: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          if (value === 'ErsteSchritte') {
            resolve();
            this.quickstartService.startQuickstart();
          } else if (value === 'Editor') {
            resolve();
            this.quickstartService.startQuickstartEditor();
          } else if (value === 'Debugger') {
            resolve();
            this.quickstartService.startQuickstartDebugger();
          } else {
            return !value && 'You need to choose something!'
          }
        })
      }
    })
  }

  toggleNavigation() {
    if ((<any>document).fullScreenElement && (<any>document).fullScreenElement !== null || (!(<any>document).mozFullScreen && !document.webkitIsFullScreen)) {
      this.navigationFullScreen = 'app/img/navigation/exitfullscreen.png';
      if ((<any>document).documentElement.requestFullScreen) {
        (<any>document).documentElement.requestFullScreen();
      } else if ((<any>document).documentElement.mozRequestFullScreen) {
        (<any>document).documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullScreen) {
        (<any>document).documentElement.webkitRequestFullScreen((<any>Element).ALLOW_KEYBOARD_INPUT);
      }
    } else {
      this.navigationFullScreen = 'app/img/navigation/enterfullscreen.gif';
      if ((<any>document).cancelFullScreen) {
        (<any>document).cancelFullScreen();
      } else if ((<any>document).mozCancelFullScreen) {
        (<any>document).mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }

  }

  stepBackward() {
    InputComponent.stepBackward();
  }

  stepForward() {
    InputComponent.stepForward();
  }

  stopVisitorExecution() {
    InputComponent.stopVisitor();
  }

  // hide the main dropdown menu
  untoggle() {
    let dropdowns = document.getElementsByClassName('dropdown-content');
    let i;
    for (i = 0; i < dropdowns.length; i++) {
      let openDropdown = dropdowns[i];
      if (openDropdown.classList.contains('show')) {
        openDropdown.classList.remove('show');
      }
    }
  }

  // show the main dropdown menu
  toggle() {
    // on second click close (all) dropdown menus
    if (document.getElementById('myDropdown').classList.contains('show')) {
      this.untoggle();
    }
    // show dropdown
    else {
      this.untoggle();
      document.getElementById('myDropdown').classList.toggle('show');
    }
  }

  // show the turtle picture
  toggleTurtleChoice() {
    // on second click close (all) dropdown menus
    if (document.getElementById('myDropdownSpeed').classList.contains('show')) {
      this.untoggle();
    }
    // show dropdown
    else {
      this.untoggle();
      document.getElementById('myDropdownSpeed').classList.toggle('show');
    }

  }

  // how the language dropdown menu
  toggleLanguage() {
    // on second click close (all) dropdown menus
    if (document.getElementById('myDropdownLanguage').classList.contains('show')) {
      this.untoggle();
    }
    // show dropdown
    else {
      this.untoggle();
      document.getElementById('myDropdownLanguage').classList.toggle('show');
    }
  }

  // show the mat dropdown menu
  toggleMat() {

    swal({
      title: "Hintergrundbild wählen",
      html: '<table style="width:100%">' +
        '<tr>' +
        '<th><img onclick="window.setMat(\'a.jpg\');" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/a_tn.jpg" alt="" height=100 width=100 on></img></th>' +
        '<th><img onclick="window.setMat(\'b.jpg\');" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/b_tn.jpg" alt="" height=100 width=100></img></th>' +
        '<th><img onclick="window.setMat(\'c.jpg\');" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/c_tn.jpg" alt="" height=100 width=100></img></th>' +
        '</tr>' +
        '<tr>' +
        '<td><img onclick="window.setMat(\'d.jpg\');" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/d_tn.jpg" alt="" height=100 width=100></img></td>' +
        '<td><img onclick="window.setMat(\'e.jpg\');" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/e_tn.jpg" alt="" height=100 width=100></img></td>' +
        '<td><img onclick="window.setMat(\'f.jpg\');" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/f_tn.jpg" alt="" height=100 width=100></img></td>' +
        '</tr>' +
        '<tr>' +
        '<td><img onclick="window.setMat(\'g.jpg\');" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/g_tn.jpg" alt="" height=100 width=100></img></td>' +
        '<td><img onclick="window.setMat(\'h.jpg\');" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/h_tn.jpg" alt="" height=100 width=100></img></td>' +
        '<td><img onclick="window.setMat(\'i.jpg\');" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/i_tn.jpg" alt="" height=100 width=100></img></td>' +
        '</tr>' +
        '<tr>' +
        '<td><img onclick="window.setMat(\'j.jpg\');" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/j_tn.jpg" alt="" height=100 width=100></img></td>' +
        '<td><img onclick="window.setMat(\'k.jpg\');" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/k_tn.jpg" alt="" height=100 width=100></img></td>' +
        '<td><img onclick="window.setMat(\'none\');" onmouseover="document.body.style.cursor = \'pointer\';" onmouseout="document.body.style.cursor = \'default\';" src="app/img/bluebotmats/none.png" alt="" height=100 width=100></img></td>' +
        '<td> </td>' +
        '</tr>' +
        '</table>'
    });
  }


  setTurtle(location: string) {
    // draw new image
    CanvasComponent.img = new Image();
    CanvasComponent.img.src = 'app/img/turtles/turtle' + location + '.png';
    CanvasComponent.img.addEventListener('load', CanvasComponent.turtleImgLoadFunction);
    // set menu icon accordingly
    this.iconTurtleVariable = 'app/img/turtles/turtle' + location + '.png';
  }

  showfeatures() {
    //read featurelist
    var url = "../features.txt";

    var jsonFile = new XMLHttpRequest();
    jsonFile.open("GET", url, true);
    jsonFile.send();

    jsonFile.onreadystatechange = function () {
      if (jsonFile.readyState == 4 && jsonFile.status == 200) {
        swal("NEW FEATURES:", jsonFile.responseText);
      }
    }
  }

  showCheatsheet() {
    var win = window.open("https://xlogo.inf.ethz.ch/Cheatsheet.pdf", '_blank');
    //win.focus();
  }

  // change the system language to english
  setLangEn() {
    this.la.setLang((new EnglishService).getLang());
    this.iconVariable = 'app/img/countryIcons/english.png';
    this.la.space.next("english");
  }

  // change the system language to german
  setLangDe() {
    this.la.setLang((new GermanService).getLang());
    this.iconVariable = 'app/img/countryIcons/german.png';
    this.la.space.next("german");
  }

  // change the system language to italian
  setLangIt() {
    this.la.setLang((new ItalianService).getLang());
    this.iconVariable = 'app/img/countryIcons/italian.png';
    this.la.space.next("italian");
  }

  setMat(name) {
    if (name === "none") {
      //set background to none
      document.getElementById('canvasD').style.background = "initial";
      CanvasComponent.MULTIPLIER = CanvasComponent.STROKE_LENGTH_MULTIPLIER;
    } else if (name === "d.jpg" || name === "g.jpg") {
      //long pictures
      CanvasComponent.MULTIPLIER = CanvasComponent.STROKE_LENGTH_MULTIPLIER * 2.2;
      document.getElementById('canvasD').style.backgroundImage = "url('app/img/bluebotmats/" + name + "')";
      document.getElementById('canvasD').style.backgroundRepeat = "no-repeat";
      document.getElementById('canvasD').style.backgroundPosition = "top center";
      document.getElementById('canvasD').style.opacity = "0.6";
      document.getElementById('canvasD').style.backgroundSize = "68%";
    } else {
      //set background to picture given through parameter and set line length to factor 2.2
      CanvasComponent.MULTIPLIER = CanvasComponent.STROKE_LENGTH_MULTIPLIER * 2.2;
      document.getElementById('canvasD').style.backgroundImage = "url('app/img/bluebotmats/" + name + "')";
      document.getElementById('canvasD').style.backgroundRepeat = "no-repeat";
      document.getElementById('canvasD').style.backgroundPosition = "top center";
      document.getElementById('canvasD').style.opacity = "0.6";
      document.getElementById('canvasD').style.backgroundSize = "35%";
    }
  }

  // save the editors content
  saveFile() {
    let text = this.et.prepareEditorTabContentForSaving();

    // construct fileName consisting of current date and the word Logo
    let dateObj = new Date();
    let month = dateObj.getUTCMonth() + 1;
    let day = dateObj.getUTCDate();
    let year = dateObj.getUTCFullYear();
    let currDate = day + '/' + month + '/' + year;

    //download file
    this.et.downloadFile('Logo ' + currDate + '.lgo', text);
  }

}
// vim: shiftwidth=2



// WEBPACK FOOTER //
// ./src/app/components/header.component.ts